import { render, staticRenderFns } from "./ChallengePassword.vue?vue&type=template&id=2139b0af&scoped=true&"
import script from "./ChallengePassword.vue?vue&type=script&lang=js&"
export * from "./ChallengePassword.vue?vue&type=script&lang=js&"
import style0 from "./ChallengePassword.vue?vue&type=style&index=0&id=2139b0af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2139b0af",
  null
  
)

export default component.exports